var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { isArray } from 'lodash';
import { breakpoints, theme } from '@shapeable/theme';
import { Select, useLang } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
var cls = classNames('prompt-variable-select');
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    max-width: 500px;\n    display: flex;\n    flex-direction: column;\n  "], ["\n    width: 100%;\n    max-width: 500px;\n    display: flex;\n    flex-direction: column;\n  "])))
});
var SelectStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n\n    .shp--select__control {\n      border-radius: 8px;\n    }\n\n    .shp--select__placeholder {\n      color: ", ";\n      margin-left: 5px;\n    }\n\n    .shp--base-select__input-container {\n      margin-left: -2px;\n    }\n\n    .shp--select__value-container {\n      padding-left: 0;\n    }\n\n    .shp--slim-select__menu {\n      background-color: #333;\n      color: #FFF;\n    }\n\n    .shp--slim-select__menu-list {\n      padding-bottom: 0;\n    }\n\n    .shp--slim-select__option {\n      border-color: #666;\n\n      &:last-child {\n        border: none;\n      }\n    }\n\n  "], ["\n    width: 100%;\n\n    .shp--select__control {\n      border-radius: 8px;\n    }\n\n    .shp--select__placeholder {\n      color: ", ";\n      margin-left: 5px;\n    }\n\n    .shp--base-select__input-container {\n      margin-left: -2px;\n    }\n\n    .shp--select__value-container {\n      padding-left: 0;\n    }\n\n    .shp--slim-select__menu {\n      background-color: #333;\n      color: #FFF;\n    }\n\n    .shp--slim-select__menu-list {\n      padding-bottom: 0;\n    }\n\n    .shp--slim-select__option {\n      border-color: #666;\n\n      &:last-child {\n        border: none;\n      }\n    }\n\n  "])), theme.COLOR('text-subtle'))
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    font-size: 0.8em;\n    text-transform: uppercase;\n    color: ", ";\n    padding: ", " ", " ", ";\n  "], ["\n    display: flex;\n    font-size: 0.8em;\n    text-transform: uppercase;\n    color: ", ";\n    padding: ", " ", " ", ";\n  "])), theme.COLOR('text'), theme.UNIT(1), theme.UNIT(1), theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Select: styled(Select)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  Label: styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
var promptVariableSelectOnChange = function (onChange) {
  return function (value) {
    if (isArray(value)) {
      onChange(value.map(function (item) {
        return item.value;
      }));
    } else {
      if (value) {
        onChange(value.value);
      } else {
        onChange(null);
      }
    }
  };
};
export var PromptVariableSelect = function (props) {
  var className = props.className,
    children = props.children,
    value = props.value,
    disabled = props.disabled,
    options = props.options,
    title = props.title,
    contextEntity = props.contextEntity,
    autoFocus = props.autoFocus;
  var t = useLang();
  return React.createElement(My.Container, {
    title: title,
    className: cls.name(className)
  }, React.createElement(My.Label, null, t(title)), React.createElement(My.Select, {
    autoFocus: autoFocus,
    isDisabled: disabled,
    isClearable: false,
    value: value ? {
      label: value,
      value: value
    } : null,
    placeholder: t('Select one'),
    onChange: promptVariableSelectOnChange(props.onChange),
    showSearchIcon: false,
    options: options
  }));
};
PromptVariableSelect.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;